import React from "react";
import { createRoot } from "react-dom/client";

import "./styles/tailwind.css";
import * as Pages from "./pages";

Object.keys(Pages).forEach((key) => {
  const Page = Pages[key];
  const elementId = key
    .replace(/([A-Z])/g, "-$1")
    .slice(1)
    .toLowerCase();
  const element = document.getElementById(elementId);
  if (element) {
    // data-* attributes are how a PHP page hands an island what the server
    // already decided (e.g. data-calling on show_customer1.php). Values are
    // strings; a page that wants a boolean compares against "true".
    // eslint-disable-next-line react/jsx-props-no-spreading
    createRoot(element).render(<Page {...element.dataset} />);
  }
});
